var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.stepName,staticStyle:{"position":"relative"}},[_c('IbanForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }